module.exports.iri = require('./iri');
module.exports.duration = require('./duration');
module.exports['idn-email'] = require('./idn-email');
module.exports['idn-hostname'] = require('./idn-hostname');
module.exports['iri-reference'] = require('./iri-reference');
